<template>
    <div class="container">
        <div class="card">
            <div class="card-body p-2">
                <div class="d-flex">
                    <div class="mr-2 flex-fill">
                        <input v-model.trim="keyword"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="電話/誕生日/User名/UserID"></input>
                    </div>
                </div>
                <div class="text-muted"><small>※営業のみ絞りたい場合、「★」で検索</small></div>
            </div>
        </div>

        <div v-show="keyword" class="list" :style="{height:wrapperHeight + 'px'}">
            <div class="wrapper" ref="wrapper">
                <div class="card">
                    <ul class="list-group list-group-flush border-bottom-0">
                        <li class="list-group-item" v-for="item in list" :key="item.id">
                            <tech-row :item="item"></tech-row>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TechRow from './Row'
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            TechRow
        },
        data () {
            return {
                keyword: '',
                list:[],
                time: null,
                wrapperHeight: $(window).height() - 167,
            }
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        watch: {
            keyword () {
                if (!this.keyword) {
                    this.list = []
                    this.$parent.showTechLevel()
                    return
                }

                this.$parent.hideTechLevel()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    result = this.getTechLevel.techs.filter((item)=>
                        item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 
                        //|| item.invite_code.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        || item.user_id.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        || item.sales_mark.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        || item.phone.indexOf(this.keyword.toLowerCase()) != -1
                        || (item.year + item.month + item.day).indexOf(this.keyword.toLowerCase()) != -1
                    )
                    this.list = result
                }, 100)
            }
        },
        computed: {
            hasNoSearchData () {
                return !this.list.length
            },
            ...mapGetters(['getTechLevel'])
        },
        methods: {
            toTechChild (code,name,level) {
                this.$parent.toTechChild(code,name,level)
            },
            toPerson (userId) {
                this.$parent.toPerson(userId)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0
</style>
